import { render, staticRenderFns } from "./FacebookLogin.vue?vue&type=template&id=3ed46207&scoped=true"
import script from "./FacebookLogin.vue?vue&type=script&lang=js"
export * from "./FacebookLogin.vue?vue&type=script&lang=js"
import style0 from "./FacebookLogin.vue?vue&type=style&index=0&id=3ed46207&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed46207",
  null
  
)

export default component.exports